import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const TabContext = React.createContext();

const TabContextProvider = ({ children }) => {
    const [tabIndex, setTabIndex] = useState(null);
    const [tabTouched, setTabTouched] = useState(false);
    const [mustSave, setMustSave] = useState(false);

    useEffect(() => {
        if (tabIndex !== null) {
            return;
        }

        setTabIndex((parseInt(window.location.hash.substring(4)) || 1) - 1);
    }, [tabIndex, setTabIndex]);

    const handleTabChange = useCallback(
        (index) => {
            if (index === tabIndex) {
                return;
            }

            if (tabTouched) {
                return setMustSave(true);
            }

            setTabIndex(index);
        },
        [tabIndex, tabTouched, setMustSave, setTabIndex]
    );

    if (!tabTouched && mustSave) {
        setMustSave(false);
    }

    return (
        <TabContext.Provider
            value={{ tabIndex, setTabIndex: handleTabChange, tabTouched, setTabTouched, mustSave, setMustSave }}
        >
            {children}
        </TabContext.Provider>
    );
};

TabContextProvider.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default TabContextProvider;
